'use es6';

import { combineReducers } from 'redux';
import { CODE_EDITOR_TOGGLE_COMPILED_SPLIT_SCREEN, FETCH_ATTRIBUTES_META, RECEIVE_ATTRIBUTES_META } from 'DesignData/actions/ActionTypes';

function showCompiledSplitScreen(state = false, action) {
  switch (action.type) {
    case CODE_EDITOR_TOGGLE_COMPILED_SPLIT_SCREEN:
      {
        if (action.data.isOverriden) return false;
        return action.data.isOpen;
      }

    case FETCH_ATTRIBUTES_META:
    case RECEIVE_ATTRIBUTES_META:
      {
        const {
          showCompiledSplitScreen: show
        } = action.designManagerUserSettings;
        return show === !!show ? show : state;
      }

    default:
      return state;
  }
}

export default combineReducers({
  showCompiledSplitScreen
});